import PropTypes from "prop-types"

export const MULTI_LINE_ITEM_SHAPE = PropTypes.shape({
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  color: PropTypes.string,
  disabled: PropTypes.bool,
  defaultDisabled: PropTypes.bool,
  colorSlot: PropTypes.number,
  category: PropTypes.string,
  type: PropTypes.oneOf(["overall", "factors", "category", "factor"]),
})

// The grouped, family-wide metric list the popover picks from; shared across MultiLineGraph, LegendPanel and AddSeriesPopover.
export const ADD_SERIES_METRICS_SHAPE = PropTypes.arrayOf(PropTypes.shape({
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
}))

export const SERIES_SELECTION_SHAPE = PropTypes.shape({
  pinColorSlots: PropTypes.func.isRequired,
})
